// --- Dependencies -------------------------------------------------------------------------------
import { create } from "zustand";
// --- Our Modules --------------------------------------------------------------------------------
import type { TyPopupStore } from "./types";
// --- Logic --------------------------------------------------------------------------------------
/** Popups are never rendered inline in a screen — they are added here and drawn by `PopupPaper`. */
const usePopup = create<TyPopupStore>()((set) => ({
    comps: [],
    closing: [],

    addComp: (comp) =>
        set((state) => ({
            comps: [
                ...state.comps.filter((item) => item.name !== comp.name),
                { anim: "fade", place: "center", cover: "shaded", coverClose: true, ...comp },
            ],
            closing: state.closing.filter((name) => name !== comp.name),
        })),

    removeComp: (name) =>
        set((state) => ({
            comps: state.comps.filter((comp) => comp.name !== name),
            closing: state.closing.filter((item) => item !== name),
        })),

    requestClose: (name) => set((state) => (state.closing.includes(name) ? state : { closing: [...state.closing, name] })),
}));

export default usePopup;
